import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { ReactElement } from "react";
import * as React from "react";

import { Collection } from "../../../../generated/gql/graphql";

type Props = {
  name: string;
  activeCollectionId?: string;
  collections: Collection[];
};

export default function LeftNavigationSubheader(props: Props): ReactElement {
  const { name, collections, activeCollectionId } = props;

  function onClickCollection(collectionId: string): void {
    window.location.href = `/collection/${collectionId}`;
  }

  return (
    <Accordion className="accordion">
      <AccordionSummary
        className="m-0"
        expandIcon={<ExpandMore />}
        aria-controls={`}`}
        id={`subheader-${name}`}
      >
        <ListItemText primary={name} />
      </AccordionSummary>
      <AccordionDetails className="p-0">
        <List component="div" disablePadding>
          {collections &&
            collections.map((item) => {
              return (
                <ListItemButton
                  selected={item.id === activeCollectionId}
                  className="border-t-1 border-solid border-slate-300 pl-[30px]"
                  key={item.id}
                  sx={{ pl: 6 }}
                >
                  <ListItemText
                    onClick={() => onClickCollection(item.id)}
                    primary={item.name}
                  />
                  {/* <IconButton onClick={() => handleDeleteCollection(item)}>
                                        <DeleteOutlineIcon />
                                    </IconButton> */}
                </ListItemButton>
              );
            })}
        </List>
      </AccordionDetails>
    </Accordion>
  );
}
